import reporter from "@/tracker/report/reporter";
import { getPage } from "@/tracker/shared/global";
import {
  Footer,
  offTrackerClickEventListener,
  onTrackerClickEventListener,
} from "@gdesign/footer";
import { useEffect, useRef } from "react";

import "@gdesign/footer/style.css";

export { default as getFooterDataSource } from "./getDataSource";

export default function LayoutFooter({ dataSource = { pits: [] } }) {
  const footerRef = useRef(null);

  const trackerClickEventListener = (data) => {
    const pageName = getPage();
    const trackData = {
      event_id: 39008,
      event_name: "button_click",
      module_name: "页底导航",
      subject_name: "按钮",
      button_name: data.detail.button_name,
      ...pageName,
    };
    reporter(trackData);
  };

  useEffect(() => {
    onTrackerClickEventListener(trackerClickEventListener);
    return () => {
      offTrackerClickEventListener(trackerClickEventListener);
    };
  }, []);

  useEffect(() => {
    if (typeof window === "undefined" || !footerRef.current) return;

    const isWindows = navigator.userAgent.toLowerCase().includes("windows");
    if (!isWindows) return;

    const timer = setTimeout(() => {
      // 先找到「客户端」区域
      const allElements = footerRef.current.querySelectorAll("*");
      const clientTitle = Array.from(allElements).find(
        (el) => el.textContent.trim() === "客户端"
      );

      if (!clientTitle?.parentElement) return;

      // 在「客户端」区域内查找「稿定 APP」
      const clientSection = clientTitle.parentElement;
      const allLinks = clientSection.querySelectorAll("a");
      const gaodingLink = Array.from(allLinks).find(
        (link) => link.textContent.trim() === "稿定 APP"
      );

      if (!gaodingLink?.parentElement) return;

      // 已存在「花瓣美思」链接 不插入
      const isExisting = Array.from(clientSection.querySelectorAll("a")).find(
        (link) => link.textContent.trim() === "花瓣美思"
      );
      if (isExisting) return;

      // 创建「花瓣美思」链接的包装容器
      const wrapper = document.createElement("div");
      wrapper.className = gaodingLink.parentElement.className;

      const meisiLink = document.createElement("a");
      meisiLink.href = "https://s.dancf.com/4rtL"; // 轻舟配置的短链接
      meisiLink.target = "_blank";
      meisiLink.rel = "nofollow";
      meisiLink.className = gaodingLink.className;
      meisiLink.textContent = "花瓣美思";

      wrapper.appendChild(meisiLink);

      // 在「稿定 APP」后面插入「花瓣美思」
      gaodingLink.parentElement.parentElement.insertBefore(
        wrapper,
        gaodingLink.parentElement.nextSibling
      );
    }, 100);

    return () => clearTimeout(timer);
  }, [dataSource]);

  return (
    <div ref={footerRef}>
      <Footer dataSource={dataSource} portal="huaban" />
    </div>
  );
}
